import { jwtDecode } from 'jwt-decode';
import * as Env from 'widget/env';

const useHandleTyping = (setIsTyping: Env.SetState<boolean>) => {
  const handleTyping = (
    message: Env.Message | undefined,
    accessToken: string,
  ) => {
    const user = jwtDecode<Env.User>(accessToken);
    if (message?.sender_id == user.user_id) return;

    setIsTyping(message?.status == 'active');
  };

  return handleTyping;
};

export default useHandleTyping;
